import axios from "axios";

export async function getMasterClassDataWithAbTest(id:string,abTestType:string,fetchBxBatchWa?:boolean){
  
  const res = await axios.get(
    `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/landing-page/${id}?abtest=true&abtesttype=${abTestType}&fetchBxBatchWa=${!!fetchBxBatchWa}`,
    {
      headers: {
        "Accept-Encoding": "gzip",
      },
    }
  );
  return res;
  
}
export async function getMasterClassData(id:string){
  
    const res = await axios.get(
       `${process.env.NEXT_PUBLIC_BASE_API}masterclasses/landing-page/${id}`,
       {
         headers: {
           "Accept-Encoding": "gzip",
         },
       }
     );
    return res;
}

export interface TokenObj {
  token: string;
  discountedPrice: string;
}

export async function getBootcampData(id: string) {
  const res = await axios.get(
    `${process.env.NEXT_PUBLIC_BASE_API}bootcamps/landing-page/${id}`,
    {
      headers: {
        "Accept-Encoding": "gzip",
      },
    }
  );
  return res;
}

export function getToken(tokenKey?:string):TokenObj|null{
  switch (tokenKey) {
    //11Rs
    case"997k": 
        return {token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOiIxMSIsImlhdCI6MTc1MDI0MjQ1M30.2VkihdsQbMOYGjtBYob0-r56aC7YVLFAfcJ5AXYJpvE', discountedPrice: '11'}

    case "2uio":
      return {token: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOiIyMSIsImlhdCI6MTc1NDk5MTIxNH0.1dNiUFYZW0RAkIDjI54w2aifdcESDUWEWzCR4L7BneQ', discountedPrice: '21'}
    //49Rs
    case 'd6a2':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjQ5LCJpYXQiOjE3NDg3NzY3Njl9.YWouYKlhcufX10h_1Le17BI8e4TQZh-dbqKGa3qIYU8', discountedPrice:'49'}
    //51Rs
    case '599k':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOiI1MSIsImlhdCI6MTc1MDQyMzk3M30.HNiWump2ii0PFj_jFOEKftu0l7MaFfKlH7F6-F_keoo', discountedPrice:'51'}
    //99Rs.
    case '293o':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjk5LCJpYXQiOjE3NDg3NzY4MTB9.hKvsaFKxa_kP5om4hKShEI6lOucDQ88qX6p0oW06xhU', discountedPrice:'99'}
          //101Rs
    case '456v':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOiIxMDEiLCJpYXQiOjE3NTA0MjQwMDB9._3aUze6nL_WxHjru9Nala31DsZOmfz0OjGPuDjWC8qc', discountedPrice:'101'}
    //199Rs.
    case 'l1y3':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjE5OSwiaWF0IjoxNzQ4Nzc2ODI4fQ.pZBbZiGi6ulTjC0IG23nNQzF1gfxQP4Lwql_qklD2Uc', discountedPrice:'199'}
    //299Rs.
    case '892g':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjI5OSwiaWF0IjoxNzQ4Nzc2ODY2fQ.Zil5-8vjqyxnh0oYOKCHZx-1q8B-o7UjSsT10RIwJuk', discountedPrice:'299'}
    //499Rs.
    case '909g':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjQ5OSwiaWF0IjoxNzQ5MzkyNDE4fQ.5AkknoBCGa0bQdD7USn9FOFHO4Vka3hPZb9i0UMahSk', discountedPrice:'499'}
    //501Rs.
    case '9o89':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOiI1MDEiLCJpYXQiOjE3NTA1MDAyODJ9.zxht0DRYpFhq3ctPEH0hXTEmptcaEatyoUWB8_azsV4', discountedPrice:'501'}
    case '7q11':
      return {token:'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJhbW91bnQiOjExMDAsImlhdCI6MTc1Mzc5NDQ5Mn0.cbPdrqNVTHydzXWn5kcUvGwwEd0WnjU0qdChKZdJAfY', discountedPrice:'1100'}
    default:
      return null;
  }
}